import { createContext } from 'react';

export const AssetOwnerContext = createContext([]);
